import AccountUsageComponent from './account-usage';

export default class AccountUsageVerticalComponent extends AccountUsageComponent {}
